<template>
  <div>
    <a v-on:click.prevent="showModal = true" class="delete" href="#">{{ $t("group.deleteMember.delete") }}</a>
      <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('group.deleteMember.modal.header', {name: memberName})" @close="showModal = false">
        <p class="modal-text" v-html="$t('group.deleteMember.modal.text')"></p>
        <a v-on:click.prevent="deleteMember" class="button" href="#">{{ $t("group.deleteMember.modal.button") }}</a>
      </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { groupService } from '@/services/group.service'

export default {
  props: ['memberName', 'appUserId', 'groupId'],
  name: 'DeleteMember',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteMember: function () {
      groupService.deleteOwner(this.groupId, this.appUserId).then(() => {
        this.showModal = false
        this.$router.go(0)
      }).catch((err) => {
        console.error('Unable to delete group member: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
a.delete {
  display: block;
  width: 16px;
  height: 20px;
  margin-left: 30px;
  background: url('../../assets/icons/trash-can.png') no-repeat;
  text-indent: -9999px;
  white-space: nowrap;
}

.modal-text {
  font-weight: bold;
}
</style>
